import React, { FC, useState } from 'react';
import { styled } from 'linaria/react';
import { SegmentedControl, SegmentedControlItem } from '@shared/ui/organisms';
import { SectionItemType } from '../model/section.types';
interface HelpSectionSwitcherProps {
  sections: SectionItemType[];
}
const HelpSectionSwitcher: FC<HelpSectionSwitcherProps> = ({
  sections
}) => {
  const [activeSectionIndex, setActiveSectionIndex] = useState<number>(0);
  const handleControlItemClick = (index: number) => {
    setActiveSectionIndex(index);
  };
  return <HelpSectionSwitcherWrapper>
      <SegmentedControl size="m">
        {sections.map(section => <SegmentedControlItem key={section.label} type="button" label={section.label} onItemClick={handleControlItemClick} />)}
      </SegmentedControl>
      <SectionContentWrapper>{sections[activeSectionIndex].content}</SectionContentWrapper>
    </HelpSectionSwitcherWrapper>;
};
export default HelpSectionSwitcher;
const HelpSectionSwitcherWrapper = /*#__PURE__*/styled('div')({
  name: "HelpSectionSwitcherWrapper",
  class: "hywrglf",
  propsAsIs: false
});
const SectionContentWrapper = /*#__PURE__*/styled('div')({
  name: "SectionContentWrapper",
  class: "s1b1btli",
  propsAsIs: false
});

require("./HelpSectionSwitcher.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./HelpSectionSwitcher.tsx");